import React, { useState } from "react";
import styled from "@emotion/styled";
import useSWR from "swr";
import { Navigate } from "react-router-dom";
import RequestCard from "../components/RequestCard";

const STATUSES = [
  { key: "pending", label: "대기중" },
  { key: "processed", label: "처리 완료" },
];

function InboxPage() {
  // 모든 hook 은 early return 위에서 호출 (rules-of-hooks).
  const { data: me } = useSWR("/manager/change-request/me");
  const [status, setStatus] = useState("pending");
  // 승인자 자격 게이트 — 서버(me.is_approver)가 단일 출처: 점장(4)↑ 또는 감정관리자(is_appraisal_manager, 직급 무관).
  // 감정관리자는 매니저(3)여도 감정 검수 1차 승인자로 지정될 수 있어 받은 요청을 열어야 한다.
  // (구버전 API 호환: is_approver 미존재 시 level 4↑ 로 폴백)
  const isApprover =
    me?.is_approver !== undefined ? Boolean(me.is_approver) : Number(me?.level || 0) >= 4;

  // isApprover 가 아니면 null 을 넘겨 fetch 자체를 막는다.
  const { data, isLoading } = useSWR(
    isApprover ? `/manager/change-request?box=inbox&status=${status}` : null,
    { refreshInterval: status === "pending" ? 30000 : 0 }
  );

  // 승인 자격이 없는 직원이 직접 URL 로 진입하면 보낸 요청 화면으로 보냄 (안전망)
  if (me && !isApprover) {
    return <Navigate to="/sent" replace />;
  }

  const items = data?.items || [];

  return (
    <Wrapper>
      <Tabs>
        {STATUSES.map((s) => (
          <Tab
            key={s.key}
            active={s.key === status ? 1 : 0}
            onClick={() => setStatus(s.key)}
          >
            {s.label}
          </Tab>
        ))}
      </Tabs>

      {isLoading && <Loading>불러오는 중...</Loading>}
      {!isLoading && items.length === 0 && (
        <Empty>받은 요청이 없습니다.</Empty>
      )}
      <List>
        {items.map((item) => (
          <RequestCard key={item.id} item={item} perspective="inbox" />
        ))}
      </List>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Tabs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #ffffff;
  border: 1px solid #e6e8eb;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 4px;
`;
const Tab = styled.button`
  height: 40px;
  border: 0;
  border-radius: 999px;
  background: ${({ active }) => (active ? "#003580" : "transparent")};
  color: ${({ active }) => (active ? "#ffffff" : "#222222")};
  font-size: 14px;
  font-weight: 500;
`;
const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Empty = styled.div`
  text-align: center;
  color: #888;
  padding: 32px 0;
  font-size: 14px;
`;
const Loading = styled(Empty)``;

export default InboxPage;
